import React from 'react'
import '../styles/VehicleRegistration.css'
import Footer from '../components/Footer'
import Card from '../components/Card'
import BackButton from '../components/BackButton'

// Import Lucide icons
import { Banknote, AlertTriangle } from 'lucide-react'

const VehicleRegistration = () => {
  return (
    <div className='registration-container'>
      {/* Back Button */}
      <div className='p-4'>
        <BackButton />
      </div>
      
      <div className='mt-16 text-center'>
        <h2 className='text-2xl font-semibold text-gray-800 dark:text-white tracking-wide'>
          Vehicle Registration Services
        </h2>
        <div className='mt-3 w-[300px] h-1 bg-blue-500 mx-auto rounded'></div>
        <p className='mt-4 text-lg text-gray-600 dark:text-gray-300'>
          Register your vehicle quickly and easily with RTO Bharat
        </p>
      </div>

      <div className='registration-cards-container'>
        <Card
          title='Vehicle Tax'
          content='Pay your vehicle tax online with ease.'
          lcolor='bg-blue-500 hover:bg-cyan-600'
          icon={Banknote}
        />
        <Card
          title='Challan'
          content='Check and pay your traffic challans online.'
          lcolor='bg-blue-500 hover:bg-cyan-600'
          icon={AlertTriangle}
        />
      </div>
      
      <div className="footer-spacer"></div>
      <Footer />
    </div>
  )
}

export default VehicleRegistration